import { atom } from 'jotai'
import { ListFilter, ListerFilterTrx, MemberList } from '../domain'
import { atomWithReset } from 'jotai/utils'

const list: MemberList = {
  dataList: [],
  paging: {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  },
}

export const listAtom = atom<MemberList>(list)

export const listFilterAtom = atomWithReset<ListFilter>({
  filterList: [],
  orderList: [{ type: 2, key: 'CreatedDate' }],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})

export const listFilterTrxAtom = atom<ListerFilterTrx>({
  filterList: [],
  orderList: [{ type: 2, key: 'CreatedDate' }],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})

export const listFilterMarketingAtom = atom<ListerFilterTrx>({
  filterList: [],
  orderList: [{ type: 2, key: 'CreatedDate' }],
  paging: {
    currentPageNumber: 1,
    pageSize: 10,
  },
})
